enum SDSInboundStatuses {
  'airport-preslot' = 1,
  'processing' = 2,
  'driver-preslot' = 3,
  'driver' = 4,
  'complete' = 5
}

export default SDSInboundStatuses;



// WEBPACK FOOTER //
// ./src/enum/SDS-inbound-status.enum.ts